import { render, staticRenderFns } from "./EXErrorState.vue?vue&type=template&id=8899f886&scoped=true"
import script from "./EXErrorState.vue?vue&type=script&setup=true&lang=js"
export * from "./EXErrorState.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EXErrorState.vue?vue&type=style&index=0&id=8899f886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8899f886",
  null
  
)

export default component.exports